import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DropButton } from '../drops/DropButton'
import { DropPaper } from '../drops/DropPaper'
import { ManagePFPFeeDialog } from '../drops/ManagePFPFeeDialog'
import { formatWAX } from '../helpers/FormatLinks'
import MainButton from '../common/util/input/MainButton'

export const PFPFeeEditor = ({ collectionName }) => {
    const [feeBalance, setFeeBalance] = useState(0)
    const [feeManagementDialogOpen, setFeeManagementDialogOpen] =
        useState(false)

    useEffect(() => {}, [collectionName])

    const { t } = useTranslation('common')

    return (
        <DropPaper id={'FeeEditor'} title={t('drops.pfp_fees')}>
            {feeBalance !== null ? (
                <div className="flex justify-center mt-4">
                    <div>
                        <div className="mb-2 text-center">
                            {t('drops.pfp_fee_balance')}:{' '}
                            <span className="text-primary font-bold">
                                {formatWAX(feeBalance)}
                            </span>
                            <div className="flex justify-center my-2">
                                <MainButton
                                    fullWidth
                                    className="w-full sm:w-60"
                                    onClick={() => {
                                        setFeeManagementDialogOpen(true)
                                    }}
                                >
                                    {' '}
                                    {t('drops.manage_fees')}
                                </MainButton>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
            <ManagePFPFeeDialog
                open={feeManagementDialogOpen}
                setOpen={setFeeManagementDialogOpen}
                collectionName={collectionName}
                feeBalance={feeBalance}
                setFeeBalance={setFeeBalance}
            />
        </DropPaper>
    )
}
